import { render, staticRenderFns } from "./ApplyViewDetail.vue?vue&type=template&id=154950e6&scoped=true"
import script from "./ApplyViewDetail.vue?vue&type=script&lang=js"
export * from "./ApplyViewDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplyViewDetail.vue?vue&type=style&index=0&id=154950e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154950e6",
  null
  
)

export default component.exports